module.exports = __webpack_public_path__ + "static/ath_card-4ecfecca4b2c8a95a4d3b1095debe8e4.svg";